@for (step of steps; track step; let i = $index) {
  <div class="step" [class.active]="currentStep === i">
    <a>{{ i + 1 }}</a>
    @if (!layoutService.isTabletDownView.value) {
      <span>{{ steps[i] }}</span>
    }
  </div>
}
